<template>
  <div class="container">
    <div>
      <b-loading v-if="isFetchingAttributes" :active="isFetchingAttributes" :is-full-page="false" />

      <template v-else>
        <div v-if="accountTags.length" class="card has-border-top has-border-grey-lighter">
          <div class="pad-md has-border-bottom has-border-grey-lighter is-flex justify-end">
            <b-button
              type="is-primary"
              icon-left="plus"
              @click="openAddEditUserAttributeModal()"
            >
              Account Tag
            </b-button>
          </div>
          <b-table
            :data="accountTags"
            class="is-middle-aligned no-header-wrap registered-guest-table"
          >
            <b-table-column
              v-slot="{ row: { name } }"
              field="name"
              sortable
              label="Name"
              cell-class="no-wrap-text"
            >
              <span
                :class="{'has-text-grey-light': !name}"
              >
                {{ name }}
              </span>
            </b-table-column>

            <b-table-column
              v-slot="{ row: { description } }"
              field="description"
              label="Description"
            >
              <span :class="{'has-text-grey-light': !description}">
                {{ description }}
              </span>
            </b-table-column>

            <b-table-column
              v-slot="{ row }"
              centered
              sortable
              field="isActive"
              label="Active"
            >
              <b-icon
                :icon="row.isActive ? 'check' : 'times'"
                :type="row.isActive ? 'is-success' : 'is-danger'"
                size="is-small"
              />
            </b-table-column>

            <b-table-column
              v-slot="{ row }"
              centered
              cell-class="actions"
              label="Actions"
              width="1"
            >
              <dropdown-menu
                v-if="$can('update', 'GiftCard')"
                position="bottom-end"
              >
                <b-button
                  slot="trigger"
                  class="is-transparent"
                  type="is-white"
                >
                  <b-icon
                    icon="ellipsis-v"
                    pack="far"
                    size="is-small"
                  />
                </b-button>
                <b-dropdown-item
                  v-if="row.isActive"
                  @click="openAddEditUserAttributeModal(row)"
                >
                  <b-icon
                    icon="pencil"
                    size="is-small"
                    class="mar-r-xs"
                  />
                  Edit
                </b-dropdown-item>
                <b-dropdown-item @click="confirmToggleUserAttributeIsActive(row)">
                  <b-icon
                    :icon="row.isActive ? 'ban' : 'bolt'"
                    :type="row.isActive ? 'is-danger' : 'is-success'"
                    class="mar-r-xs"
                    size="is-small"
                  />
                  {{ row.isActive ? 'Deactivate' : 'Activate' }}
                </b-dropdown-item>
              </dropdown-menu>
            </b-table-column>
          </b-table>
        </div>
        <empty-state-card
          v-else
          type="is-primary"
          title="Create Tag"
          message="Create a new tab to engage with categorize your customers"
          icon="paper-plane"
        >
          <template #buttons>
            <b-button
              type="is-primary"
              rounded
              icon-left="plus"
              @click="openAddEditUserAttributeModal()"
            >
              New Account Tag
            </b-button>
          </template>
        </empty-state-card>
      </template>
    </div>
  </div>
</template>

<script>
  import AlertModal from '@/components/globals/alert-modal.vue';

  import capitalCase from '@/helpers/capitalCase';

  import scrollIndicatorMixin from '@/mixins/scroll-container-indicator';

  import UserAttribute from '@/store/classes/UserAttribute';

  import AddEditAccountTagModal from './add-edit-account-tag-modal.vue';


  export default {
    name: 'AccountTagsList',

    mixins: [scrollIndicatorMixin],

    data() {
      return {};
    },

    computed: {
      accountTags() {
        return UserAttribute.query().orderBy('name').get();
      },

      isFetchingAttributes() {
        return UserAttribute.$state().fetching;
      }
    },

    created() {
      this.onCreated();
    },

    methods: {
      async onCreated() {
        await UserAttribute.fetchAttributes();

        this.$_initScrollIndicatorSmart({
          contentSelector: '.table'
        });
      },

      openAddEditUserAttributeModal(userAttribute) {
        this.$buefy.modal.open({
          canCancel: ['escape', 'outside'],
          component: AddEditAccountTagModal,
          customClass: 'auto-width',
          hasModalCard: true,
          parent: this,
          props: { userAttribute }
        });
      },

      confirmToggleUserAttributeIsActive(userAttribute) {
        const action = userAttribute.isActive ? 'deactivate' : 'activate';

        const payload = {
          ...userAttribute,
          isActive: !userAttribute.isActive
        };

        this.$buefy.modal.open({
          parent: this,
          component: AlertModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: ['escape', 'outside'],
          customClass: 'auto-width',
          props: {
            title: `${capitalCase(action)} Account Tag`,
            message: `This action will <em>${action}</em> the <b>${userAttribute.name}</b> Account Tag`,
            secondaryMessage: 'Are you sure you would like to proceed?',
            horizontal: true,
            showCloseButton: false,
            icon: 'bolt',
            pack: userAttribute.isActive ? 'far' : 'fas',
            type: userAttribute.isActive ? 'is-danger' : 'is-success',
            buttons: [
              { text: 'Cancel' },
              {
                text: `${capitalCase(action)}`,
                primary: true,
                onClick: () => this.updateUserAttribute(payload)
              }
            ]
          }
        });
      },

      async updateUserAttribute(payload) {
        try {
          await UserAttribute.updateAttribute(payload);

          this.$_onRequestSuccess({
            toastOptions: {
              message: `Successfully updated account tag <b>${payload.name}</b>!`
            },
            options: {
              closeParent: true
            }
          });
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: `Unable to update account tag <b>${payload.name}</b>`
            }
          });
        }
      }
    }
  };
</script>

<style lang="sass" scoped>
  .search-section
    display: flex

    .query-input,
    .search-inputs
      flex: 1 1

  .result-count
      padding: 0.5rem 0

  ::v-deep
    tr.row-pointer:hover
      cursor: pointer
</style>
